import Swiper from 'swiper'

window.addEventListener('DOMContentLoaded', () => {
  // 研修の現場特集カルーセル
  const specialSwiper = document.querySelectorAll('.m__carousel--special .special-swiper')
  const specialPrev = document.querySelectorAll('.m__carousel--special .swiper-button-prev')
  const specialNext = document.querySelectorAll('.m__carousel--special .swiper-button-next')
  const specialPage = document.querySelectorAll('.m__carousel--special .swiper-pagination')
  if (specialSwiper.length > 0) {
    for (let i = 0; i < specialSwiper.length; i++) {
      specialSwiper[i].className += i
      specialPrev[i].className += i
      specialNext[i].className += i
      specialPage[i].className += i
      const sliderCount = specialSwiper[i].children[0].children.length
      let loopSetting = true
      let effectType = 'fade'
      if (sliderCount > 1) {
        loopSetting = true
      } else {
        loopSetting = false
      }
      if (window.innerWidth < 768) {
        effectType = 'slide'
      }
      const swiper = new Swiper ('.special-swiper' + i, {
        'loop': loopSetting,
        'slidesPerView': 1,
        'spaceBetween': 20,
        'effect': effectType,
        'centeredSlides': true,
        'autoplay': {
          delay: 5000,
        },
        'pagination': {
          'el': '.m__carousel--special .js-swiper-paging' + i,
          'type': 'bullets',
          'clickable': true
        },
        'navigation': {
          'nextEl': '.m__carousel--special .js-swiper-next' + i,
          'prevEl': '.m__carousel--special .js-swiper-prev' + i
        },
        'watchOverflow': true,
        'breakpoints': {
          '768': {
            'slidesPerView': 3,
            'spaceBetween': 10
          }
        },
      })

    }
  }


  // レジナビのイチオシカルーセル
  const recommendSwiper = document.querySelectorAll('.m__carousel--recommend .recommend-swiper')
  const recommendPrev = document.querySelectorAll('.m__carousel--recommend .swiper-button-prev')
  const recommendNext = document.querySelectorAll('.m__carousel--recommend .swiper-button-next')
  const recommendPage = document.querySelectorAll('.m__carousel--recommend  .swiper-pagination')
  if (recommendSwiper.length > 0) {
    for (let i = 0; i < recommendSwiper.length; i++) {
      recommendSwiper[i].className += i
      recommendPrev[i].className += i
      recommendNext[i].className += i
      recommendPage[i].className += i
      const sliderCount = recommendSwiper[i].children[0].children.length
      let loopSetting = true
      if (sliderCount > 1) {
        loopSetting = true
      } else {
        loopSetting = false
      }
      const swiper = new Swiper ('.recommend-swiper' + i, {
        'loop': loopSetting,
        'slidesPerView': 1,
        'spaceBetween': 0,
        'autoplay': {
          delay: 5000,
        },
        'pagination': {
          'el': '.m__carousel--recommend .js-swiper-paging' + i,
          'type': 'bullets',
          'clickable': true
        },
        'navigation': {
          'nextEl': '.m__carousel--recommend .js-swiper-next' + i,
          'prevEl': '.m__carousel--recommend .js-swiper-prev' + i
        },
        'watchOverflow': true,
        'breakpoints': {
          '768': {
            'slidesPerView': 3,
            'centeredSlides': true,
            'spaceBetween': 15
          }
        },
      })
    }
  }
})
